import { sortBy } from 'es-toolkit'

import type { Application } from '@subaio/api-types/financedata'
import { type Page, request } from '@subaio/utils'

import { submitOAuthForm } from './submitOAuthForm'

export const initializeMcpApplications = async ({ query }: { query: Page['query'] }, abortIfCancelled: () => void) => {
	if (query?.application !== '1') return { applications: [] }

	const applications = sortBy(
		await request<Array<Application>>({ url: '/mcp-oauth/oauth2/applications', credentials: 'same-origin' }),
		[(application) => application.type],
	)
	abortIfCancelled()
	if (applications.length === 1) {
		await submitOAuthForm('/mcp-oauth/oauth2/application', {
			applicationId: applications[0].id,
			correlation: typeof query.correlation === 'string' ? query.correlation : '',
		})
	}
	return { applications }
}
